import { useState, useRef } from "react";
import { Upload, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export const ImageUploadField = ({ slug, value, onChange, testId, placeholder = "https://… " }) => {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post(`/associations/${slug}/upload`, fd);
      onChange(data.url);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-2">
      {value && (
        <img src={value} alt="" className="h-9 w-9 rounded-md object-cover border border-border shrink-0" />
      )}
      <Input data-testid={testId} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="flex-1 min-w-0" />
      <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={upload} data-testid={`${testId}-file-input`} />
      <Button type="button" variant="outline" size="icon" data-testid={`${testId}-upload-btn`} onClick={() => fileRef.current?.click()} disabled={uploading} className="h-9 w-9 shrink-0">
        {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
      </Button>
    </div>
  );
};
